"use client"

import HomeDetailsWrapperAccordion from "../home-details-wrapper-accordion"
import FormYesNoInput from "../../../../shared/components/form-inputs/form-yes-no-input"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import { useFormContext } from "react-hook-form"
const baseFieldName = "home.homeStatusInfo"


function HomeHomeStatusForm() {
    const { control, watch } = useFormContext<HomeWithHomeOwnerFormType>()
    
    
    return (
        <HomeDetailsWrapperAccordion heading="Home Status">
            <FormYesNoInput 
                inputGroupProps={{
                    label: "Is There Known Lead Paint in Home?"
                }}
                name={`${baseFieldName}.leadPaint`}
                control={control}
            />
            <FormYesNoInput
                inputGroupProps={{
                    label: "Do we have permission to work with residents gone?"
                }}
                name={`${baseFieldName}.permissionToWork`}
                control={control}
            />
             <FormYesNoInput
                inputGroupProps={{
                    label: "Is the roof currently leaking?"
                }}
                name={`${baseFieldName}.roofLeaking`}
                control={control}
            />

            <FormYesNoInput
                inputGroupProps={{
                    label: "Is the home currently occupied?"
                }}
                name={`${baseFieldName}.CurrentlyOccupied`}
                control={control}
            />
            <FormYesNoInput
                inputGroupProps={{
                    label: "Has the Media Waiver been signed?"
                }}
                name={`${baseFieldName}.mediaWaiverSigned`}
                control={control}
            />
            <FormYesNoInput
                inputGroupProps={{
                    label: "Has the Work Waiver been signed?"
                }}
                name={`${baseFieldName}.workWaiverSigned`}
                control={control}
            />
            <FormYesNoInput
                inputGroupProps={{
                    label: "Help Needed is within Work Scopes"
                }}
                name={`${baseFieldName}.helpWithinScope`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeHomeStatusForm
